import React, { useState } from "react";
import { useDispatch } from "react-redux";
import userStore from "../../zustand/userStore";
import { updateUserPasswordThunk } from "./redux/userThunk";

const UpdatePassword = ({ userId, onClose }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const [passwordData, setPasswordData] = useState({ password: "", confirmPassword: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.password !== passwordData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    try {
      await dispatch(
        updateUserPasswordThunk({
          userId,
          password: passwordData.password,
          dbName: userData?.db_name || "",
        })
      ).unwrap();
      alert("Password updated successfully!");
      onClose();
    } catch (err) {
      alert(err || "Failed to update password");
    }
  };

  return (
    <form onSubmit={handlePasswordSubmit}>
      <div style={{ marginBottom: "12px" }}>
        <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>New Password</label>
        <div className="position-relative">
          <input
            type={showPassword ? "text" : "password"}
            className="form-control pe-5"
            style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
            placeholder="Enter new password"
            value={passwordData.password}
            onChange={(e) => setPasswordData({ ...passwordData, password: e.target.value })}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3"
            style={{ cursor: "pointer" }}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <i
              className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
              style={{ fontSize: "12px" }}
            ></i>
          </span>
        </div>
      </div>
      <div style={{ marginBottom: "16px" }}>
        <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Confirm Password</label>
        <div className="position-relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            className="form-control pe-5"
            style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
            placeholder="Confirm new password"
            value={passwordData.confirmPassword}
            onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
            required
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3"
            style={{ cursor: "pointer" }}
            onClick={() => setShowConfirmPassword((prev) => !prev)}
          >
            <i
              className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
              style={{ fontSize: "12px" }}
            ></i>
          </span>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={onClose}
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-primary btn-sm">
          Submit
        </button>
      </div>
    </form>
  );
};

export default UpdatePassword;
